<template>
  <div class="min-h-screen bg-gray-50">
    <div class="bg-white shadow-sm border-b border-gray-200">
      <div
        class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 flex items-center justify-between"
      >
        <div>
          <h1 class="text-3xl font-bold text-gray-900">Причины ухода</h1>
          <p class="mt-1 text-sm text-gray-500">Справочник причин ухода</p>
        </div>
        <button
          @click="openCreateModal"
          class="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-lg shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors duration-200"
        >
          <i class="pi pi-plus mr-2"></i> Добавить причину
        </button>
      </div>
    </div>
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <div v-if="loading" class="flex justify-center items-center py-12">
        <div
          class="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"
        ></div>
      </div>
      <div
        v-else-if="error"
        class="bg-white rounded-lg shadow-sm border border-red-200 p-6"
      >
        <div class="flex items-center">
          <div class="flex-shrink-0">
            <i class="pi pi-exclamation-triangle text-red-400 text-xl"></i>
          </div>
          <div class="ml-3">
            <h3 class="text-sm font-medium text-red-800">Ошибка загрузки</h3>
            <div class="mt-2 text-sm text-red-700">{{ error }}</div>
          </div>
        </div>
      </div>
      <div
        v-else-if="reasons.length === 0"
        class="bg-white rounded-lg shadow-sm border border-gray-200 p-6 text-center text-gray-500 text-lg"
      >
        Список пуст
      </div>
      <div v-else class="bg-white shadow-sm rounded-lg overflow-hidden">
        <table class="min-w-full divide-y divide-gray-200">
          <thead class="bg-gray-50">
            <tr>
              <th
                class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
              >
                ID
              </th>
              <th
                class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
              >
                Название
              </th>
              <th
                class="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider"
              >
                Действия
              </th>
            </tr>
          </thead>
          <tbody class="bg-white divide-y divide-gray-200">
            <tr
              v-for="reason in reasons"
              :key="reason.id"
              :class="[
                reason.is_deleted
                  ? 'bg-gray-100 text-gray-400'
                  : 'hover:bg-blue-50',
                'transition-colors duration-150'
              ]"
            >
              <td class="px-6 py-4 whitespace-nowrap">{{ reason.id }}</td>
              <td class="px-6 py-4 whitespace-nowrap">{{ reason.name }}</td>
              <td
                class="px-6 py-4 whitespace-nowrap text-right text-sm font-medium"
              >
                <div class="flex items-center justify-end space-x-2">
                  <button
                    v-if="!reason.is_deleted"
                    @click="openEditModal(reason)"
                    class="text-blue-600 hover:text-blue-900 transition-colors duration-150"
                    title="Редактировать"
                  >
                    <i class="pi pi-pencil"></i>
                  </button>
                  <button
                    v-if="!reason.is_deleted"
                    @click="openDeleteModal(reason)"
                    class="text-red-600 hover:text-red-900 transition-colors duration-150"
                    title="Удалить"
                  >
                    <i class="pi pi-trash"></i>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div v-if="showModal" class="fixed inset-0 z-50 overflow-y-auto">
      <div
        class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0"
      >
        <div
          class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
          @click="closeModal"
        ></div>
        <div
          class="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-md sm:w-full"
        >
          <div class="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
            <div class="sm:flex sm:items-start">
              <div class="mt-3 text-center sm:mt-0 sm:text-left w-full">
                <h3 class="text-lg leading-6 font-medium text-gray-900 mb-4">
                  {{
                    modalMode === 'create'
                      ? 'Добавить причину'
                      : 'Редактировать причину'
                  }}
                </h3>
                <form @submit.prevent="submitForm">
                  <div class="mb-4">
                    <label class="block text-sm font-medium text-gray-700 mb-1"
                      >Название *</label
                    >
                    <input
                      v-model="formData.name"
                      type="text"
                      required
                      class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                    />
                  </div>
                  <div
                    class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse"
                  >
                    <button
                      type="submit"
                      :disabled="submitting"
                      class="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-blue-600 text-base font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:ml-3 sm:w-auto sm:text-sm disabled:opacity-50 disabled:cursor-not-allowed transition-colors duration-200"
                    >
                      <span
                        v-if="submitting"
                        class="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"
                      ></span>
                      {{ modalMode === 'create' ? 'Создать' : 'Сохранить' }}
                    </button>
                    <button
                      type="button"
                      @click="closeModal"
                      :disabled="submitting"
                      class="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm disabled:opacity-50 disabled:cursor-not-allowed transition-colors duration-200"
                    >
                      Отмена
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Модальное окно подтверждения удаления -->
    <div v-if="showDeleteModal" class="fixed inset-0 z-50 overflow-y-auto">
      <div
        class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0"
      >
        <div
          class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
          @click="closeDeleteModal"
        ></div>

        <div
          class="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full"
        >
          <div class="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
            <div class="sm:flex sm:items-start">
              <div
                class="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10"
              >
                <i class="pi pi-exclamation-triangle text-red-600 text-xl"></i>
              </div>
              <div class="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                <h3 class="text-lg leading-6 font-medium text-gray-900">
                  Подтверждение удаления
                </h3>
                <div class="mt-2">
                  <p class="text-sm text-gray-500">
                    Вы действительно хотите удалить причину ухода
                    <strong>"{{ entityToDelete?.name }}"</strong>?
                  </p>
                  <p class="text-sm text-gray-500 mt-2">
                    Это действие нельзя отменить.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
            <button
              @click="confirmDelete"
              :disabled="submitting"
              class="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-red-600 text-base font-medium text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:ml-3 sm:w-auto sm:text-sm disabled:opacity-50 disabled:cursor-not-allowed transition-colors duration-200"
            >
              <span
                v-if="submitting"
                class="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"
              ></span>
              Удалить
            </button>
            <button
              @click="closeDeleteModal"
              :disabled="submitting"
              class="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm disabled:opacity-50 disabled:cursor-not-allowed transition-colors duration-200"
            >
              Отмена
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
  import { ref, onMounted } from 'vue'
  import { reasonOfLeavingApi } from '../services/api'
  import { useToast } from 'primevue/usetoast'

  const reasons = ref([])
  const loading = ref(false)
  const error = ref('')
  const showModal = ref(false)
  const showDeleteModal = ref(false)
  const modalMode = ref('create')
  const submitting = ref(false)
  const formData = ref({ id: '', name: '' })
  const entityToDelete = ref(null)
  const toast = useToast()

  const fetchReasons = async () => {
    loading.value = true
    error.value = ''
    try {
      const data = await reasonOfLeavingApi.getList()
      reasons.value = data.reasons_of_leaving || data || []
    } catch (e) {
      error.value = 'Ошибка загрузки данных'
    } finally {
      loading.value = false
    }
  }

  function openCreateModal() {
    showModal.value = true
    modalMode.value = 'create'
    formData.value = { id: '', name: '' }
  }

  function openEditModal(reason) {
    showModal.value = true
    modalMode.value = 'edit'
    formData.value = { ...reason }
  }

  function closeModal() {
    showModal.value = false
  }

  async function submitForm() {
    if (!formData.value.name.trim()) {
      toast.add({
        severity: 'error',
        summary: 'Ошибка',
        detail: 'Название обязательно',
        life: 3000
      })
      return
    }
    submitting.value = true
    try {
      if (modalMode.value === 'create') {
        await reasonOfLeavingApi.create({ name: formData.value.name })
        toast.add({
          severity: 'success',
          summary: 'Успешно',
          detail: 'Причина добавлена',
          life: 3000
        })
      } else {
        await reasonOfLeavingApi.update(formData.value.id, {
          name: formData.value.name
        })
        toast.add({
          severity: 'success',
          summary: 'Успешно',
          detail: 'Причина обновлена',
          life: 3000
        })
      }
      closeModal()
      await fetchReasons()
    } catch (err) {
      const errorData = err.response?.data
      let errorMessage = 'Не удалось сохранить'
      
      const details = errorData?.data?.details || errorData?.details
      
      if (details) {
        const firstField = Object.keys(details)[0]
        if (firstField) {
          const fieldError = details[firstField]
          if (Array.isArray(fieldError) && fieldError.length > 0) {
            errorMessage = `${firstField}: ${fieldError[0]}`
          } else if (typeof fieldError === 'string') {
            errorMessage = `${firstField}: ${fieldError}`
          }
        }
      } else if (errorData?.data?.message) {
        errorMessage = errorData.data.message
      } else if (errorData?.message) {
        errorMessage = errorData.message
      } else if (err.message) {
        errorMessage = err.message
      }
      
      toast.add({
        severity: 'error',
        summary: 'Ошибка',
        detail: errorMessage,
        life: 5000
      })
    } finally {
      submitting.value = false
    }
  }

  function openDeleteModal(reason) {
    entityToDelete.value = reason
    showDeleteModal.value = true
  }

  function closeDeleteModal() {
    showDeleteModal.value = false
    entityToDelete.value = null
  }

  async function confirmDelete() {
    if (!entityToDelete.value) return

    submitting.value = true
    try {
      await reasonOfLeavingApi.delete(entityToDelete.value.id)
      toast.add({
        severity: 'success',
        summary: 'Успешно',
        detail: 'Причина ухода удалена',
        life: 3000
      })
      closeDeleteModal()
      await fetchReasons()
    } catch {
      toast.add({
        severity: 'error',
        summary: 'Ошибка',
        detail: 'Не удалось удалить причину ухода',
        life: 3000
      })
    } finally {
      submitting.value = false
    }
  }

  onMounted(fetchReasons)
</script>
